import Axios from 'axios';

export const axios =   (token) =>  Axios.create({headers: {"Authorization": "Bearer " + token }})

    
export const configAxios = (token) =>{
        return {headers: {"Authorization": "Bearer " + token }}
}
